import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ConstrainedOnceSequenceClass;
function ConstrainedOnceSequence() {
  if (ConstrainedOnceSequenceClass === VOID) {
    class $ {
      constructor(sequence) {
        this.pg_1 = sequence;
      }
      u1() {
        var tmp0_elvis_lhs = this.pg_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('This sequence can be consumed only once.');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var sequence = tmp;
        this.pg_1 = null;
        return sequence.u1();
      }
    }
    initMetadataForClass($, 'ConstrainedOnceSequence');
    ConstrainedOnceSequenceClass = $;
  }
  return ConstrainedOnceSequenceClass;
}
//region block: exports
export {
  ConstrainedOnceSequence as ConstrainedOnceSequence3d7vfvt49occh,
};
//endregion

//# sourceMappingURL=sequenceJs.mjs.map
